import api from './api';

// 字典类型
export interface DictType {
  id: string;
  name: string;
  code: string;
  status: number;
  remark: string;
  createdAt: string;
  updatedAt: string;
}

// 字典数据
export interface DictData {
  id: string;
  typeId: string;
  typeCode: string;
  label: string;
  value: string;
  sort: number;
  status: number;
  isDefault: number;
  cssClass: string;
  listClass: string;
  remark: string;
  createdAt: string;
  updatedAt: string;
}

// ==================== 字典类型 ====================

// 获取字典类型列表
export const listTypes = (params: {
  page?: number;
  pageSize?: number;
  name?: string;
  code?: string;
  status?: string;
}) => {
  return api.get<{ list: DictType[]; total: number }>('/dict/types', { params });
};

// 获取所有字典类型
export const getAllTypes = () => {
  return api.get<DictType[]>('/dict/types/all');
};

// 创建字典类型
export const createType = (data: {
  name: string;
  code: string;
  status?: number;
  remark?: string;
}) => {
  return api.post<DictType>('/dict/types', data);
};

// 更新字典类型
export const updateType = (id: string, data: {
  name?: string;
  code?: string;
  status?: number;
  remark?: string;
}) => {
  return api.put<DictType>(`/dict/types/${id}`, data);
};

// 删除字典类型
export const deleteType = (id: string) => {
  return api.delete(`/dict/types/${id}`);
};

// ==================== 字典数据 ====================

// 获取字典数据列表
export const listData = (params: { typeId?: string; typeCode?: string }) => {
  return api.get<DictData[]>('/dict/data', { params });
};

// 根据字典编码获取字典数据
export const getDataByCode = (code: string) => {
  return api.get<DictData[]>(`/dict/data/code/${code}`);
};

// 创建字典数据
export const createData = (data: {
  typeId: string;
  label: string;
  value: string;
  sort?: number;
  status?: number;
  isDefault?: number;
  cssClass?: string;
  listClass?: string;
  remark?: string;
}) => {
  return api.post<DictData>('/dict/data', data);
};

// 更新字典数据
export const updateData = (id: string, data: {
  label?: string;
  value?: string;
  sort?: number;
  status?: number;
  isDefault?: number;
  cssClass?: string;
  listClass?: string;
  remark?: string;
}) => {
  return api.put<DictData>(`/dict/data/${id}`, data);
};

// 删除字典数据
export const deleteData = (id: string) => {
  return api.delete(`/dict/data/${id}`);
};

// 列表样式选项
export const listClassOptions = [
  { label: '默认', value: '' },
  { label: '主要', value: 'primary' },
  { label: '成功', value: 'success' },
  { label: '信息', value: 'info' },
  { label: '警告', value: 'warning' },
  { label: '危险', value: 'danger' },
];
